// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__yYLWl","validationTips":"StatementDescriptor_validationTips__2Kveh"};